<h2 class="confirmation-title" mat-dialog-title>{{ confirmation.title }}</h2>
<mat-dialog-content class="confirmation-message">
  <p>{{ confirmation.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button class="action-btn cancel-btn" (click)="onCancel()">Cancel</button>
  <button mat-button class="action-btn ok-btn" color="primary" (click)="onConfirm()" [disabled]="!isFormValid()">OK</button>
</mat-dialog-actions>
